(function () {
  'use strict';
  const handles = ['custom-logo-designed-chocolate-bars', 'custom-logo-design-oreos-dipped-in-chocolate'];
  const handle = location.pathname.split('/products/')[1]?.split('/')[0];
  if (!handles.includes(handle)) return;
  function normalize(input) {
    input.min = '25';
    input.dataset.min = '25';
    const value = Number(input.value);
    if (!Number.isFinite(value) || value < 25) input.value = '25';
    const minus = input.closest('quantity-input, .quantity')?.querySelector('button[name="minus"]');
    if (minus) {
      minus.disabled = Number(input.value) <= 25;
      minus.classList.toggle('disabled', minus.disabled);
    }
  }
  function init() {
    document.querySelectorAll('input[name="quantity"]').forEach(input => {
      if (input.dataset.stMinBound) return;
      input.dataset.stMinBound = '1';
      normalize(input);
    });
  }
  document.addEventListener('change', event => {
    if (event.target.matches('input[name="quantity"]')) normalize(event.target);
  }, true);
  document.addEventListener('blur', event => {
    if (event.target.matches('input[name="quantity"]')) normalize(event.target);
  }, true);
  document.addEventListener('submit', event => {
    if (!event.target.matches('form[action*="/cart/add"]')) return;
    document.querySelectorAll('input[name="quantity"]').forEach(input => {
      if (input.form === event.target) normalize(input);
    });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();